import Cookies from 'js-cookie';
import dayjs from "dayjs";

class StaffAccessToken {
  StaffId: string | undefined;
  exp: number | undefined;
}

export function isStaffLoggedIn() : boolean {
  var token = getStaffToken();
  if (typeof token === 'undefined' || token === '') {
    return false
  }
  var base64Url = token.split('.')[1]
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))
  let accountToken = JSON.parse(jsonPayload) as StaffAccessToken;
  let expiry = dayjs.unix(accountToken.exp!);
  return expiry > dayjs();
}

export function saveStaffToken(token:string): void {
  Cookies.set('drop_staff_access_token', token);
}

export function getStaffToken() : string | undefined {
  return Cookies.get('drop_staff_access_token');
}

class AccountToken {
  AccountId: string | undefined;
  CompanyId: string | undefined;
  exp: number | undefined;
}

export function getAccountId() : string | undefined {
  var token = getToken();
  if (typeof token === 'undefined' || token === '' || token === "null") {
    return undefined;
  }
  return JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))).account_id;
}

export function isLoggedIn() : boolean {
  var token = getToken();
  if (typeof token === 'undefined' || token === '' || token === "null") {
    return false
  }
  var base64Url = token.split('.')[1]
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))
  let accountToken = JSON.parse(jsonPayload) as AccountToken;
  let expiry = dayjs.unix(accountToken.exp!);
  return expiry > dayjs();
}

export function saveToken(token:string): void {
  Cookies.set('drop_access_token', token);
}

export function getToken() : string | undefined {
  return Cookies.get('drop_access_token');
}

export function removeToken() {
  Cookies.remove('drop_access_token');
}

export function saveReferrerIfNotSet() {
  if (Cookies.get('referrer') == null || Cookies.get('referrer') == '') {
    if(!window.document.referrer.startsWith(window.location.origin)) {
      Cookies.set('referrer', window.document.referrer);
    }
  }
}

export function getReferrer() {
  return Cookies.get('referrer');
}